import { FlagConfig } from './flag-catalog.types';

/**
 * Deeply freeze a catalog entry: clone and freeze the nested closed-set arrays
 * (`enum.values`, `variant.variants`) BEFORE freezing the entry itself, so no
 * reference held by the caller can mutate the catalog after construction. A
 * shallow `Object.freeze` would leave those arrays writable.
 *
 * Both `defineFlags` and `composeCatalog` run this on every entry. `defineFlags`
 * freezes the entries it mints; `composeCatalog` re-freezes on store because it
 * also accepts hand-rolled/untyped fragments whose entries never passed through
 * `defineFlags` — the re-freeze defends the composition root against a mutable
 * `config` (or a mutable nested `values`/`variants`) leaking into `FLAG_CATALOG`.
 */
export function freezeEntry(config: FlagConfig): FlagConfig {
    if (config.type === 'enum') {
        return Object.freeze({ ...config, values: Object.freeze([...config.values]) });
    }
    if (config.type === 'variant') {
        return Object.freeze({ ...config, variants: Object.freeze([...config.variants]) });
    }
    return Object.freeze({ ...config });
}
